/* eslint-disable*/
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect } from 'react';
import Loader from '../../../../components/Loader/Loader';
import { Box, Grid, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import usePractice from '../../../../hooks/usePractice';
import PopupState, { bindTrigger, bindPopover, bindHover } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
/* CSS */
import useStyles from '../../Main.style';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';

const SummaryInvoiceByCountry = ({
  reportArr,
  myCountryInvoiceArray,
  myProfitRevenue,
  dashboardComments,
  dashboardSectionText,
}) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [isLoaded, setIsLoaded] = useState(true);

  async function findColumnObject(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findColumnObject(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findColumnObject(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase() == searchText.toLowerCase()
            ) {
              //console.log('Object found: ', obj);
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  async function findObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              //console.log('Object found: ', obj);
              return { object: obj };
            }
          }
        }
      }
    }
    return null;
  }

  const fillPastDueTotals = async (reportObj) => {
    const pastDueColumns = await findColumnObject(reportObj?.reportResult, 'Customer');

    let requiredColumnIndex = 0;
    pastDueColumns?.parent.map((c, i) => {
      if (c.ColTitle == '16 and over') {
        requiredColumnIndex = i;
      }
    });

    const pastDueInvTotalYtd = await findObjectBySearchText(reportObj?.reportResult, 'GrandTotal');
    const pastDueAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex];

    setPastDueInvoicesObject([
      ...pastDueInvoicesObject,
      { pastDueTotal: pastDueAmt?.value || 0, country: reportObj?.country },
    ]);
  };

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, []);

  const formatData = (data, styles) => {
    if (!data || data?.length === 0) {
      return '$0';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return <Typography className={styles.TableTextRed}>{formattedValue}</Typography>;
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* PROFIT COMPONENT */}

        <Box className={classes.innercontentWhite} height="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5" noWrap>
              INVOICING -{' '}
              {loggedInUserData?.department?.departmentTitle?.toUpperCase() + ' LOGIWARE'}
            </Typography>
            <InfoPopover />
          </Box>
          <Box mt={1} className={classes.TableUIV2}>
            <MaterialTable
              style={{ boxShadow: 'none' }}
              options={{
                toolbar: false,
                draggable: false,
                paging: false,
                sorting: true,
                pageSize: 20,
                pageSizeOptions: [10, 20, 50, 100],
                showTextRowsSelected: false,
                toolbarButtonAlignment: 'right',
                showFirstLastPageButtons: false,
                actionsColumnIndex: -100,
                emptyRowsWhenPaging: false,
              }}
              localization={{
                pagination: {
                  labelRowsSelect: 'Rows',
                  labelRowsPerPage: 'Rows Per Page',
                },
              }}
              title="Invoicing"
              columns={[
                {
                  title: new Date().getFullYear() + ' YTD',
                  field: 'ytd',
                },
                {
                  title: 'USA',
                  field: 'usa',
                },
                {
                  title: 'Mexico',
                  field: 'mexico',
                },
                {
                  title: 'Chile',
                  field: 'chile',
                },
                {
                  title: 'Peru',
                  field: 'peru',
                },
              ]}
              data={[
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: formatData(myProfitRevenue?.revenueValue, classes),
                  mexico: myCountryInvoiceArray?.[4]?.mexico ? (
                    (myCountryInvoiceArray?.[4]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray?.[4]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[4]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[4]?.chile ? (
                    (myCountryInvoiceArray[4]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[4]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[4]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[4]?.peru ? (
                    (myCountryInvoiceArray[4]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[4]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[4]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue Target"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[6]?.usa ? (
                    (myCountryInvoiceArray[6]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[6]?.usa}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[6]?.usa
                    )
                  ) : (
                    0
                  ),
                  mexico: myCountryInvoiceArray[6]?.mexico ? (
                    (myCountryInvoiceArray[6]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[6]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[6]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[6]?.chile ? (
                    (myCountryInvoiceArray[6]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[6]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[6]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[6]?.peru ? (
                    (myCountryInvoiceArray[6]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[6]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[6]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[5]?.usa ? (
                    (myCountryInvoiceArray[5]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[5]?.usa}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[5]?.usa
                    )
                  ) : (
                    0
                  ),
                  mexico: myCountryInvoiceArray[5]?.mexico ? (
                    (myCountryInvoiceArray[5]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[5]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[5]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[5]?.chile ? (
                    (myCountryInvoiceArray[5]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[5]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[5]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[5]?.peru ? (
                    (myCountryInvoiceArray[5]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[5]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[5]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Target"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[7]?.usa ? (
                    (myCountryInvoiceArray[7]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[7]?.usa}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[7]?.usa
                    )
                  ) : (
                    0
                  ),
                  mexico: myCountryInvoiceArray[7]?.mexico ? (
                    (myCountryInvoiceArray[7]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[7]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[7]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[7]?.chile ? (
                    (myCountryInvoiceArray[7]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[7]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[7]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[7]?.peru ? (
                    (myCountryInvoiceArray[7]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[7]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[7]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Average Gross Profit per File"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[3]?.usa ? (
                    (myCountryInvoiceArray[3]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[3]?.usa}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[3]?.usa
                    )
                  ) : (
                    0
                  ),
                  mexico: myCountryInvoiceArray[3]?.mexico ? (
                    (myCountryInvoiceArray[3]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[3]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[3]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[3]?.chile ? (
                    (myCountryInvoiceArray[3]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[3]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[3]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[3]?.peru ? (
                    (myCountryInvoiceArray[3]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[3]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[3]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Weighted for Complexity"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[9]?.usa ? (
                    (myCountryInvoiceArray[9]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[9]?.usa}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[9]?.usa
                    )
                  ) : (
                    0
                  ),
                  mexico: myCountryInvoiceArray[9]?.mexico ? (
                    (myCountryInvoiceArray[9]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[9]?.mexico}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[9]?.mexico
                    )
                  ) : (
                    0
                  ),
                  chile: myCountryInvoiceArray[9]?.chile ? (
                    (myCountryInvoiceArray[9]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[9]?.chile}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[9]?.chile
                    )
                  ) : (
                    0
                  ),
                  peru: myCountryInvoiceArray[9]?.peru ? (
                    (myCountryInvoiceArray[9]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[9]?.peru}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[9]?.peru
                    )
                  ) : (
                    0
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Optimal Invoice Delta"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[0]?.usa ? (
                    (myCountryInvoiceArray[0]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[0]?.usa + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[0]?.usa + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  mexico: myCountryInvoiceArray[0]?.mexico ? (
                    (myCountryInvoiceArray[0]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[0]?.mexico + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[0]?.mexico + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  chile: myCountryInvoiceArray[0]?.chile ? (
                    (myCountryInvoiceArray[0]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[0]?.chile + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[0]?.chile + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  peru: myCountryInvoiceArray[0]?.peru ? (
                    (myCountryInvoiceArray[0]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[0]?.peru + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[0]?.peru + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Active to Admin Delta"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[1]?.usa ? (
                    (myCountryInvoiceArray[1]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[1]?.usa + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[1]?.usa + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  mexico: myCountryInvoiceArray[1]?.mexico ? (
                    (myCountryInvoiceArray[1]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[1]?.mexico + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[1]?.mexico + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  chile: myCountryInvoiceArray[1]?.chile ? (
                    (myCountryInvoiceArray[1]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[1]?.chile + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[1]?.chile + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  peru: myCountryInvoiceArray[1]?.peru ? (
                    (myCountryInvoiceArray[1]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[1]?.peru + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[1]?.peru + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Admin to Closed Delta"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: myCountryInvoiceArray[2]?.usa ? (
                    (myCountryInvoiceArray[2]?.usa).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[2]?.usa + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[2]?.usa + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  mexico: myCountryInvoiceArray[2]?.mexico ? (
                    (myCountryInvoiceArray[2]?.mexico).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[2]?.mexico + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[2]?.mexico + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  chile: myCountryInvoiceArray[2]?.chile ? (
                    (myCountryInvoiceArray[2]?.chile).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[2]?.chile + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[2]?.chile + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                  peru: myCountryInvoiceArray[2]?.peru ? (
                    (myCountryInvoiceArray[2]?.peru).includes('(') ? (
                      <Typography className={classes.TableTextRed}>
                        {myCountryInvoiceArray[2]?.peru + ' Days'}
                      </Typography>
                    ) : (
                      myCountryInvoiceArray[2]?.peru + ' Days'
                    )
                  ) : (
                    '0 Days'
                  ),
                },
              ]}
            />
          </Box>
        </Box>
      </If>
    </>
  );
};

export default SummaryInvoiceByCountry;
